<template>
    <div class="">
        <Nav  bgColor="#FFFFFF" />

      <section class="container">
        <div class="row">
          <div class="col-12">

            <div class="d-flex align-items-center justify-content-center pt-3">
                <div class="d-flex align-items-center text-start text-white px-5">
                    <span class="text-uppercase text-black display-header home-text mx-2 text-center">HIRE US</span>
                </div>
            </div>
            <div class="mx-auto text-center py-3 pb-5" style="max-width: 1000px;">
        Atlas Improv Co. is available for private bookings throughout the Midwest. We specialize in providing entertainment and training customized to fit your budget, organization, and event. We have performed for countless private gatherings and led many corporate events, and we always make sure that our customers are satisfied.
        For more information, please contact us at <a class="contact-link" href="mailto:info@atlasimprov.com">info@atlasimprov.com</a>.
            </div>
          </div>
        </div></section>
      <div class="marquee-static bg-black py-3 mt-5">
        <div class="marquee-logos d-none d-sm-flex justify-content-evenly align-items-center flex-wrap">
          <img src="@/assets/AmFam.png" alt="AmFam" class="marquee-logo" />
          <img src="@/assets/4H.png" alt="4H" class="marquee-logo" />
          <img src="@/assets/Edgewood.png" alt="Edgewood" class="marquee-logo" />
          <img src="@/assets/LandsEnd.png" alt="Lands End" class="marquee-logo" />
          <img src="@/assets/MMSD.png" alt="MMSD" class="marquee-logo" />
          <img src="@/assets/R&Rins.png" alt="R&R Insurance" class="marquee-logo" />
          <img src="@/assets/Wyso.png" alt="WYSO" class="marquee-logo" />
        </div>
        <div class="marquee d-sm-none">
          <div class="marquee-track">
            <img src="@/assets/AmFam.png" alt="AmFam" class="marquee-logo" />
            <img src="@/assets/4H.png" alt="4H" class="marquee-logo" />
            <img src="@/assets/Edgewood.png" alt="Edgewood" class="marquee-logo" />
            <img src="@/assets/LandsEnd.png" alt="Lands End" class="marquee-logo" />
            <img src="@/assets/MMSD.png" alt="MMSD" class="marquee-logo" />
            <img src="@/assets/R&Rins.png" alt="R&R Insurance" class="marquee-logo" />
            <img src="@/assets/Wyso.png" alt="WYSO" class="marquee-logo" />
            <img src="@/assets/AmFam.png" alt="AmFam" class="marquee-logo" />
            <img src="@/assets/4H.png" alt="4H" class="marquee-logo" />
            <img src="@/assets/Edgewood.png" alt="Edgewood" class="marquee-logo" />
            <img src="@/assets/LandsEnd.png" alt="Lands End" class="marquee-logo" />
            <img src="@/assets/MMSD.png" alt="MMSD" class="marquee-logo" />
            <img src="@/assets/R&Rins.png" alt="R&R Insurance" class="marquee-logo" />
            <img src="@/assets/Wyso.png" alt="WYSO" class="marquee-logo" />
          </div>
        </div>
      </div>
        <div class="bg-dark w-100 pb-2" style="height: 2px;"></div>
                 <section class="container-fluid">
        <div class="row align-items-start mt-5 flex-column-reverse flex-md-row pb-3">
          <div class="col-md-5 px-5">
            <h2 class="display-5 text-uppercase oswald-bold pb-3 pt-5">PRIVATE SHOWS</h2>
            <h4 class ="oswald-bold fs-5">Full Show</h4>
            <p>Two teams of improvisers compete in a battle of wits and humor. This show has seven performers and typically lasts one and a half hours.</p>
            <h4 class="oswald-bold fs-5">Exhibition Show</h4>
            <p>A team of our improvisers play four to five hilarious and fast-paced games. This show has three performers and typically lasts between forty-five and sixty minutes.</p>

            <h2 class="display-5 text-uppercase oswald-bold pb-3">CORPORATE TRAINING</h2>
            <h4 class="oswald-bold fs-5">Teamwork</h4>
            <p>Increase trust between co-workers and eliminate the competition within teams that prevents groups from reaching their full potential. Games and exercises focus on getting to know each other, learning to succeed by making others look good, and the most important principle in all of improv, “Yes, and….”</p>
            <h4 class="oswald-bold fs-5">Innovation</h4>
            <p>Encourage participants to take positive risks by getting out of their own way. Games and exercises focus on spontaneity and overcoming barriers to ideas so creative they just might work.</p>
            <h4 class="oswald-bold fs-5">Adaptability</h4>
            <p>Participants respond positively to change. Games and exercises focus on listening, accepting the current situation, and using new opportunities to meet the needs of the present moment.</p>

            <h4 class="oswald-bold fs-5">Basic Improv Class</h4>
            <p>Kick back and just have fun, learning the ins and outs of improvisation from our professionals.</p>
          </div>

          <div class="col-md-7 px-5 position-relative">
            <img src="@/assets/Team.png" alt="Atlas Improv Team" class="img-fluid" />
            <!-- <div class="overlay-quote">
              <blockquote>
                <p><em>Atlas Improv Co. challenges its audience to ‘think on their feet’ as they participate in creative, funny and downright silly situations.</em></p>
                <cite>– Cheri Salava, CSW Social Work Supervisor, Rock County Human Services Dept.</cite>
              </blockquote>
            </div> -->
          </div>
        </div>
      </section>

      <!-- <Carousel /> -->
      <Footer />
    </div>
  </template>
<script>
import { useHead } from '@vueuse/head';
import { useRoute } from 'vue-router';
// import PageSections from '@/components/PageSections.vue';
// import AllShows from '../components/AllShows.vue';
import Footer from '../components/Footer.vue'
import Nav from "../components/Nav.vue"
// import Carousel from '@/components/Carousel.vue';

export default {
    name: 'HireUs',
    setup() {
      const route = useRoute();
      useHead({
        title: route.meta.title || 'Atlas Improv – Hire Us',
        meta: [
          {
            name: 'description',
            content: route.meta.description || 'Book Atlas Improv for private events and corporate training.'
          }
        ]
      });
      return {};
    },
    components: {
        Nav, Footer
    },

};
</script>
  <style scoped>
  /* .hire-us-pdf {
    font-family: Georgia, serif;
    color: #222;
    position: relative;
    padding: 60px 30px;
    max-width: 900px;
    margin: auto;
  } */

  .pdf-background img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    z-index: -1;
    opacity: 0.2;
  }

  .quote-icon img {
    width: 80px;
    margin-bottom: 20px;
  }

  .content h1 {
    font-size: 32px;
    font-weight: bold;
    text-align: center;
    margin-bottom: 30px;
  }

  .content h2 {
    font-size: 20px;
    font-weight: normal;
    text-transform: uppercase;
    text-align: right;
    margin-top: 60px;
  }

  .content h3 {
    font-size: 17px;
    font-weight: bold;
    margin-top: 20px;
  }

  .content p {
    font-size: 16px;
    margin-bottom: 15px;
  }

  /* .team-quote styles removed for new layout */

  .overlay-quote {
    position: absolute;
    bottom: 20px;
    left: 20px;
    right: 20px;
    color: #000;
    font-style: italic;
    background-color: rgba(255, 255, 255, 0.7);
    padding: 20px;
    border-radius: 6px;
  }

  .clients {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;
    margin-top: 40px;
  }

  .clients img {
    max-height: 50px;
    max-width: 120px;
    object-fit: contain;
  }
  .marquee-static {
    background-color: #000;
  }

  .marquee-logos {
    gap: 30px;
    padding: 10px 20px;
  }

  .marquee-logo {
    height: 50px;
    max-width: 120px;
    object-fit: contain;
  }

  .marquee {
    overflow: hidden;
    position: relative;
    background-color: #000;
    white-space: nowrap;
  }

  .marquee-track {
    display: flex;
    animation: ticker-scroll 20s linear infinite;
    gap: 30px;
    padding: 10px 0;
    will-change: transform;
  }

  @keyframes ticker-scroll {
    0% {
      transform: translateX(0%);
    }
    100% {
      transform: translateX(-50%);
    }
  }
  </style>